{
  "title": "ਤੁਹਾਡਾ ਚੈੱਕ-ਇਨ ਪੂਰਾ ਕਰਨ ਵਿੱਚ ਅਸਮਰੱਥ",
  "message": "ਤੁਹਾਡੀ ID ਦੀ ਪੁਸ਼ਟੀ ਨਹੀਂ ਕੀਤੀ ਜਾ ਸਕੀ"
}
